export default __webpack_public_path__ + "static/media/profile_tip_personal_requests.4dbf2d2c.svg";